<a href="{{href}}" class="list-group-item">
    {{header}}
</a>

